export enum PlayerEvent {
  Play = 'play-media-player',
  Pause = 'pause-media-player',
}

export enum LocalPlayerEvent {
  Running = 'running-local-media-player',
  Paused = 'paused-local-media-player',
}
